import { Outlet, Route, Routes } from "react-router-dom";

import {
    BaseModule,
    getI18n,
    MenuRoute,
    Modules,
    VirtualRouteHookProvider,
} from "scbk-services";
import { ErrorComponent, RootLayout } from "scbk-shared-module";

import { CommonConfig, LoginConfig } from "scbk-login/config";
import { MockConfig } from "scbk-login/mocks";

import "../App.css";
import { routeObjects } from "./routeObjects";

export const LoginModuleRoutes = () => {
  return (
    <BaseModule
      module={Modules.LOGIN}
      moduleConfig={LoginConfig}
      commonConfig={CommonConfig}
      mockConfig={MockConfig}
      metaEnv={import.meta.env}
    >
      <Routes>
        <Route element={<RootLayout i18n={getI18n()} />}>
          <Route element={<VirtualRouteHookProvider outlet={Outlet} />}>
            {routeObjects?.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <MenuRoute
                    id={route?.id ?? ""}
                    path={route?.fullPath ?? ""}
                  />
                }
              />
            ))}
          </Route>
        </Route>
        <Route path="*" element={<ErrorComponent errorCode="404" />} />
      </Routes>
    </BaseModule>
  );
};
